//import _ from 'lodash';
import moment from 'moment';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import { DatePicker } from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';
import FormHelperText from '@material-ui/core/FormHelperText';
import { gridMargin } from './general';
import { Button } from '@material-ui/core';

export default class FMPDatePicker extends PureComponent {
	render() {
		const {
			label,
			value,
			path,
			onChange,
			error,
			helpText,
			md,
			disabled,
			contained,
			format,
			showClearButton,
		} = this.props;

		const _onChange = (date) => {
			onChange(moment(date).format('YYYY-MM-DD'), path);
		};

		let gridStyle = { ...gridMargin };
		if (showClearButton) {
			gridStyle.position = 'relative';
		}

		const hasError = !!error;
		const content = (
			<Grid item xs={12} md={md} style={gridStyle}>
				<FormControl fullWidth={true} error={hasError} disabled={disabled}>
					<DatePicker
						label={label}
						value={value || null}
						showTodayButton
						onChange={_onChange}
						animateYearScrolling
						format={format}
						disabled={disabled}
					/>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>

				{showClearButton && (
					<div style={{ position: 'absolute', top: 10, right: 20 }}>
						<Button
							onClick={() => {
								onChange(null, path);
							}}
						>
							Clear
						</Button>
					</div>
				)}
			</Grid>
		);

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FMPDatePicker.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	helpText: PropTypes.string,
	contained: PropTypes.bool,
	disabled: PropTypes.bool,
	md: PropTypes.number,
	format: PropTypes.string,
	showClearButton: PropTypes.bool,
};

FMPDatePicker.defaultProps = {
	md: 12,
	format: 'dddd, MMMM Do',
};
